var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container"},[_c('div',{staticClass:"spinner-box"},[_c('b-spinner',{attrs:{"variant":"primary","label":"Loading..."}}),_vm._v(" "),_c('span',{staticClass:"ml-2"},[_vm._v("Loading...")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }